<template>
    <v-container fill-height
                 fluid
                 grid-list-xl>
        <v-layout wrap justify-center>
            <v-flex xs12 sm12 md8 lg8>
                <material-card class="card-tabs" color="green"
                               :title="`Survey ${typeof survey.name ==='undefined'?'':'- '+ survey.name}`">
                    <v-container py-0>
                        <v-form ref="form_survey" v-model="valid_survey" lazy-validation>
                            <v-layout wrap>
                                <v-flex xs12 md12 d-flex>
                                    <v-switch class="switch"
                                              v-model="type"
                                              :label="`Type: ${type?'Quiz':'Survey'}`"
                                              @change="isUpdateSurvey=true">
                                    </v-switch>
                                    <v-btn class="mx-0 font-weight-light"
                                           style="flex-grow: 0 !important;"
                                           color="tertiary"
                                           v-on:click="btnNewSurvey" v-if="!isCreateSurvey">
                                        <v-icon left>mdi-plus</v-icon>
                                        New Survey
                                    </v-btn>
                                </v-flex>
                                <v-flex xs12
                                        md12 mt-4>
                                    <v-text-field class="purple-input"
                                                  label="Survey Name"
                                                  :rules="required"
                                                  required
                                                  ref="surveyName"
                                                  v-model="survey.name"
                                                  @change="isUpdateSurvey=true"
                                                  autofocus/>
                                </v-flex>
                                <v-flex xs12
                                        md12>
                                    <v-text-field
                                            label="Survey Descriptions"
                                            v-model="survey.description"
                                            @change="isUpdateSurvey=true"/>
                                </v-flex>
                                <v-flex xs12 md12>
                                    <v-btn class="mx-0 font-weight-light"
                                           color="tertiary"
                                           v-on:click="btnCreateSurvey"
                                           v-if="isCreateSurvey">
                                        <v-icon left>mdi-plus</v-icon>
                                        Create
                                    </v-btn>
                                    <v-btn class="mx-0 font-weight-light"
                                           color="tertiary"
                                           v-on:click="btnUpdateSurvey"
                                           v-if="!isCreateSurvey"
                                           :disabled="!isUpdateSurvey">
                                        <v-icon left>mdi-content-save</v-icon>
                                        Save
                                    </v-btn>
                                </v-flex>
                            </v-layout>
                        </v-form>
                        <v-layout wrap v-if="showQuestionForm">
                            <v-flex xs12 md7 sm7>
                                <material-card class="card-tabs mx-1" color="orange" title="Question">
                                    <v-container class="py-0">
                                        <v-form ref="form_question" v-model="valid_question" lazy-validation>
                                            <v-layout wrap>
                                                <v-flex xs12 md12 d-flex>
                                                    <v-spacer></v-spacer>
                                                    <v-btn class="mx-0 font-weight-light"
                                                           style="flex-grow: 0 !important;"
                                                           color="tertiary" v-on:click="btnNewQuestion">
                                                        <v-icon left>mdi-plus</v-icon>
                                                        New Question
                                                    </v-btn>
                                                </v-flex>
                                                <v-flex xs12 sm12 md12>
                                                    <v-text-field
                                                            class="purple-input"
                                                            label="Question Name"
                                                            v-model="question.content"
                                                            :rules="required"
                                                            required
                                                            @change="isUpdateQuestion=true"
                                                    />
                                                </v-flex>
                                                <v-flex xs12 sm12 md12>
                                                    <v-text-field
                                                            label="Image URL"
                                                            v-model="question.image_url"
                                                            @change="isUpdateQuestion=true"/>
                                                </v-flex>
                                                <v-flex xs12 sm12 md12 d-flex
                                                        v-for="(choice_item, choice_index) in choices"
                                                        v-bind:key="choice_index">
                                                    <v-container>
                                                        <v-layout row wrap>
                                                            <v-flex xs8 sm8 md8>
                                                                <v-text-field
                                                                        class="purple-input"
                                                                        label="Choice"
                                                                        v-model="choice_item.content"
                                                                        :rules="required"
                                                                        required
                                                                        @change="isUpdateQuestion=true"/>
                                                            </v-flex>
                                                            <v-flex xs4 sm4 md4 d-flex>
                                                                <v-checkbox style="flex-grow: 0 !important;"
                                                                            color="green"
                                                                            label="True" v-if="type"
                                                                            v-model="choice_item.is_true"/>
                                                                <v-tooltip top style="flex-grow: 0 !important;"
                                                                           content-class="top"
                                                                           v-if="choices.length == choice_index + 1">
                                                                    <v-btn slot="activator"
                                                                           class="v-btn--simple"
                                                                           color="success"
                                                                           icon v-on:click="btnAddChoice">
                                                                        <v-icon color="primary">mdi-plus</v-icon>
                                                                    </v-btn>
                                                                    <span>Add Choice</span>
                                                                </v-tooltip>
                                                                <v-tooltip top
                                                                           content-class="top"
                                                                           style="flex-grow: 0 !important;">
                                                                    <v-btn slot="activator"
                                                                           class="v-btn--simple"
                                                                           color="danger"
                                                                           icon
                                                                           v-on:click="btnDeleteChoice(choice_index)">
                                                                        <v-icon color="error">mdi-trash-can-outline
                                                                        </v-icon>
                                                                    </v-btn>
                                                                    <span>Delete</span>
                                                                </v-tooltip>
                                                            </v-flex>
                                                        </v-layout>
                                                    </v-container>
                                                </v-flex>
                                                <v-flex xs12 sm12 md12>
                                                    <v-flex xs12 md12>
                                                        <v-btn class="mx-0 font-weight-light"
                                                               color="tertiary"
                                                               v-on:click="btnCreateQuestion"
                                                               v-if="isCreateQuestion">
                                                            <v-icon left>mdi-plus</v-icon>
                                                            Create Question
                                                        </v-btn>
                                                        <v-btn class="mx-0 font-weight-light"
                                                               color="tertiary"
                                                               v-on:click="btnUpdateQuestion"
                                                               v-if="!isCreateQuestion"
                                                               :disabled="!isUpdateQuestion">
                                                            <v-icon left>mdi-content-save</v-icon>
                                                            Save
                                                        </v-btn>
                                                    </v-flex>
                                                </v-flex>
                                            </v-layout>
                                        </v-form>
                                    </v-container>
                                </material-card>
                            </v-flex>
                            <v-flex xs12 sm5 md5>
                                <material-card class="card-tabs mx-1" color="orange" title="List Question">
                                    <v-list three-line>
                                        <v-list-tile v-for="question_item in questions" v-bind:key="question_item.id"
                                                     v-on:click="fillQuestionData(question_item)"
                                                     active-class="highlighted"
                                                     :class="question.id === question_item.id && !isCreateQuestion ? 'highlighted' : ''">
                                            <v-list-tile-title>
                                                {{question_item.content}}
                                            </v-list-tile-title>
                                            <div class="d-flex">
                                                <v-tooltip top
                                                           content-class="top">
                                                    <v-btn slot="activator"
                                                           class="v-btn--simple"
                                                           color="danger"
                                                           icon
                                                           @click.native.stop
                                                           v-on:click="btnDeleteQuestion(question_item)">
                                                        <v-icon color="error">mdi-trash-can-outline</v-icon>
                                                    </v-btn>
                                                    <span>Delete</span>
                                                </v-tooltip>
                                            </div>
                                        </v-list-tile>
                                    </v-list>
                                </material-card>
                            </v-flex>
                        </v-layout>
                    </v-container>
                </material-card>
            </v-flex>
            <v-flex xs12 sm12 md4 lg4>
                <material-card class="card-tabs" color="green" title="List Survey">
                    <v-list three-line>
                        <v-list-tile v-for="survey_item in surveys" v-bind:key="survey_item.token"
                                     v-on:click="fillSurveyData(survey_item)" active-class="highlighted"
                                     :class="survey.token === survey_item.token && !isCreateSurvey ? 'highlighted' : ''">
                            <v-list-tile-title>
                                {{survey_item.name}}
                            </v-list-tile-title>
                            <div class="d-flex">
                                <v-tooltip top
                                           content-class="top">
                                    <v-btn slot="activator"
                                           class="v-btn--simple"
                                           color="primary"
                                           icon
                                           @click.native.stop
                                           v-clipboard:copy="survey_item.token"
                                           v-clipboard:success="onCopySuccess"
                                           v-clipboard:error="onCopyError">
                                        <v-icon color="accent">mdi-content-copy</v-icon>
                                    </v-btn>
                                    <span>Coppy Token</span>
                                </v-tooltip>
                                <v-tooltip top
                                           content-class="top">
                                    <v-btn slot="activator"
                                           class="v-btn--simple"
                                           color="success"
                                           icon
                                           @click.native.stop
                                           :to="'/survey-report/' + survey_item.token">
                                        <v-icon color="primary">mdi-google-analytics</v-icon>
                                    </v-btn>
                                    <span>Report</span>
                                </v-tooltip>
                                <v-tooltip top
                                           content-class="top">
                                    <v-btn slot="activator"
                                           class="v-btn--simple"
                                           color="danger"
                                           icon
                                           @click.native.stop
                                           v-on:click="btnDeleteSurvey(survey_item)">
                                        <v-icon color="error">mdi-trash-can-outline</v-icon>
                                    </v-btn>
                                    <span>Delete</span>
                                </v-tooltip>
                            </div>
                        </v-list-tile>
                    </v-list>
                </material-card>
            </v-flex>
        </v-layout>
        <v-snackbar
                :color="snackbar.color"
                bottom
                right
                v-model="snackbar.show"
                dark>
            <v-icon color="white"
                    class="mr-3">
                {{snackbar.icon}}
            </v-icon>
            <div>{{snackbar.message}}</div>
            <v-icon size="16"
                    @click="snackbar.show = false">
                mdi-close-circle
            </v-icon>
        </v-snackbar>
    </v-container>
</template>
<script>
    import axios from 'axios';

    export default {
        data() {
            return {
                required: [v => !!v || "The field is required"],
                valid_survey: true,
                survey: {},
                surveys: [],
                type: false,
                isCreateSurvey: true,
                isUpdateSurvey: false,
                valid_question: true,
                question: {},
                questions: [],
                isCreateQuestion: true,
                isUpdateQuestion: false,
                showQuestionForm: false,
                choice: {},
                choices: [
                    {
                        is_true: false
                    }
                ],
                choicesDeleted: [],
                email: '',
                snackbar: {
                    color: '',
                    message: '',
                    show: false,
                    icon: ''
                },
            }
        },
        created() {
            let self = this
            self.fetchData()
        },
        methods: {
            //Notify
            showSuccessNotify(message) {
                let self = this
                self.snackbar = {
                    color: 'success',
                    message: message,
                    show: true,
                    icon: 'mdi-information-variant'
                }
            },
            showErrorNotify(message) {
                let self = this
                self.snackbar = {
                    color: 'error',
                    message: message,
                    show: true,
                    icon: 'mdi-alert-circle-outline'
                }
            },
            //Survey Method Rest API
            async getSurvey() {
                return await axios.get('/api/survey/', {withCredentials: true})
            },
            async getSurveyByToken(token) {
                return await axios.get('/api/survey/' + token + '/', {withCredentials: true})
            },
            async postSurvey(survey) {
                return await axios.post('/api/survey/', survey, {withCredentials: true})
            },
            async pacthSurvey(survey) {
                return await axios.patch('/api/survey/' + survey.token + '/', survey, {withCredentials: true})
            },
            async deleteSurvey(survey) {
                return await axios.delete('/api/survey/' + survey.token + '/', {withCredentials: true})
            },
            //Question Method Rest API
            async getQuestion(survey) {
                return await axios.get('/api/question/', {
                    headers: {
                        Authorization: 'Bearer ' + survey.token
                    }
                })
            },
            async getQuestionById(question, survey) {
                return await axios.get('/api/question/' + question.id + '/', {
                    headers: {
                        Authorization: 'Bearer ' + survey.token
                    }
                })
            },
            async postQuestion(question, survey) {
                return await axios.post('/api/question/', question, {
                    headers: {
                        Authorization: 'Bearer ' + survey.token
                    }
                })
            },
            async patchQuestion(question, survey) {
                return await axios.patch('/api/question/' + question.id + '/', question, {
                    headers: {
                        Authorization: 'Bearer ' + survey.token
                    }
                })
            },
            async deleteQuestion(question, survey) {
                return await axios.delete('/api/question/' + question.id + '/', {
                    headers: {
                        Authorization: 'Bearer ' + survey.token
                    }
                })
            },
            async postChoice(choice, question, survey) {
                choice.question = question.id
                return await axios.post('/api/choices/', choice, {
                    headers: {
                        Authorization: 'Bearer ' + survey.token
                    }
                })
            },
            async postChoices(choices, question, survey) {
                let self = this
                await choices.reduce((previousPromise, item) => {
                    return previousPromise.then(() => self.postChoice(item, question, survey))
                }, Promise.resolve())
            },
            async patchChoice(choice, question, survey) {
                choice.question = question.id
                return await axios.patch('/api/choices/' + choice.id + '/', choice, {
                    headers: {
                        Authorization: 'Bearer ' + survey.token
                    }
                })
            },
            async patchChoices(choices, question, survey) {
                let self = this
                return await Promise.all(choices.map((choice) => {
                    if (typeof choice.id === 'undefined') {
                        self.postChoice(choice, question, survey)
                    } else {
                        self.patchChoice(choice, question, survey)
                    }
                }))
            },
            async deleteChoice(choice, survey) {
                return await axios.delete('/api/choices/' + choice.id + '/', {
                    headers: {
                        Authorization: 'Bearer ' + survey.token
                    }
                })
            },
            async deleteChoices(choices, survey) {
                let self = this
                return await Promise.all(choices.map((choice) => {
                    if (typeof choice.id !== 'undefined') {
                        self.deleteChoice(choice, survey)
                    }
                }))
            },
            fetchData() {
                let self = this
                self.getSurvey()
                    .then((surveys) => self.surveys = surveys.data)
                    .catch((error) => self.showErrorNotify('Have some error:' + error))
                if (typeof self.survey.token !== 'undefined') {
                    self.getQuestion(self.survey)
                        .then((questions) => self.questions = questions.data)
                        .catch((error) => self.showErrorNotify('Have some error:' + error))
                }
            },
            //Choice Method Rest API
            // Action UI
            btnNewSurvey() {
                let self = this
                self.$refs.form_survey.reset()
                self.$refs.surveyName.focus()
                self.isCreateSurvey = true
                self.showQuestionForm = false
                self.question = {}
                self.choices = [
                    {
                        is_true: false
                    }
                ]
                self.isCreateQuestion = true
                self.isUpdateQuestion = false
            },
            btnCreateSurvey() {
                let self = this
                self.survey.type = self.type ? 'Quiz' : 'Survey'
                if (self.$refs.form_survey.validate()) {
                    self.postSurvey(self.survey)
                        .then((survey) => self.survey = survey.data)
                        .then(self.showSuccessNotify('Add Survey Success'))
                        .then(() => {
                            self.isCreateSurvey = false
                            self.isUpdateSurvey = false
                            self.showQuestionForm = true
                        })
                        .catch((error) => self.showErrorNotify('Have some error:' + error))
                        .finally(self.fetchData)
                }
            },
            btnUpdateSurvey() {
                let self = this
                self.survey.type = self.type ? 'Quiz' : 'Survey'
                if (self.$refs.form_survey.validate()) {
                    self.pacthSurvey(self.survey)
                        .then((survey) => self.survey = survey.data)
                        .then(self.showSuccessNotify('Update Survey Success'))
                        .then(() => self.isUpdateSurvey = false)
                        .catch((error) => self.showErrorNotify('Have some error:' + error))
                        .finally(self.fetchData)
                }
            },
            fillSurveyData(survey) {
                let self = this
                self.isCreateSurvey = false
                self.isUpdateSurvey = true
                self.showQuestionForm = true
                self.survey = survey
                self.type = survey.type == "Quiz"
                if (typeof self.$refs.form_question !== 'undefined') {
                    self.btnNewQuestion()
                }
                self.isCreateQuestion = true
                self.fetchData()
            },
            btnDeleteSurvey(survey) {
                let self = this
                self.$confirm('Are you sure to delete this item?').then((res) => {
                    if (res) {
                        self.deleteSurvey(survey)
                            .then(self.showSuccessNotify('Delete Survey Success'))
                            .then(() => {
                                if (survey.token == self.survey.token) {
                                    self.$refs.form_survey.reset()
                                    self.isCreateSurvey = true
                                    self.showQuestionForm = false
                                    self.question = {}
                                    self.choices = [
                                        {
                                            is_true: false
                                        }
                                    ]
                                    self.isCreateQuestion = true
                                    self.isUpdateQuestion = false
                                    self.survey = {}
                                    self.fetchData()
                                } else {
                                    self.fetchData()
                                }
                            })
                            .catch((error) => self.showErrorNotify('Have some error:' + error))
                    }
                })

            },
            btnCreateQuestion() {
                let self = this
                if (self.$refs.form_question.validate()) {
                    self.postQuestion(self.question, self.survey)
                        .then((question) => self.question = question.data)
                        .then(() => {
                            self.isCreateQuestion = false
                            self.isUpdateQuestion = false
                        })
                        .then(() => self.postChoices(self.choices, self.question, self.survey))
                        .then(() => self.btnUpdateSurvey())
                        .then(() => self.getQuestionById(self.question, self.survey))
                        .then((question) => self.choices = question.data['choices'])
                        .then(self.fetchData)
                        .then(self.showSuccessNotify('Create Question Success'))
                }
            },
            btnUpdateQuestion() {
                let self = this
                if (self.$refs.form_question.validate()) {
                    self.patchQuestion(self.question, self.survey)
                        .then((question) => self.question = question.data)
                        .then(() => {
                            self.isCreateQuestion = false
                            self.isUpdateQuestion = false
                        })
                        .then(() => self.patchChoices(self.choices, self.question, self.survey))
                        .then(() => self.deleteChoices(self.choicesDeleted, self.survey))
                        .then(() => self.choicesDeleted = [])
                        .then(self.fetchData)
                        .then(self.showSuccessNotify('Update Question Success'))
                }
            },
            btnDeleteQuestion(question) {
                let self = this
                self.$confirm('Are you sure to delete this item?').then((res) => {
                    if (res) {
                        self.deleteQuestion(question, self.survey)
                            .then(self.fetchData)
                            .then(self.showSuccessNotify('Delete Question Success'))
                            .then(() => {
                                if (question.id == self.question.id) {
                                    self.btnNewQuestion()
                                }
                            })
                            .catch((error) => self.showErrorNotify('Have some error:' + error))
                    }
                })
            },
            fillQuestionData(question) {
                let self = this
                self.choices = question['choices']
                self.question = question
                self.isCreateQuestion = false
                self.isUpdateQuestion = true
            },
            btnNewQuestion() {
                let self = this
                self.$refs.form_question.reset()
                self.isCreateQuestion = true
                self.choices = [
                    {
                        is_true: false
                    }
                ]
                self.fetchData()
            },
            btnAddChoice() {
                let self = this
                self.choices.push({
                    is_true: false
                })
            },
            btnDeleteChoice(choice_index) {
                let self = this
                if (self.choices.length > 1) {
                    self.choicesDeleted.push(self.choices[choice_index])
                    self.choices.splice(choice_index, 1);
                }
            },
            onCopySuccess() {
                let self = this
                self.showSuccessNotify('Copy Token Success')
            },
            onCopyError() {
                let self = this
                self.showErrorNotify('Copy Token Error')
            }
        }
    }
</script>

<style scoped>
    .highlighted {
        background-color: rgba(0, 0, 0, .04);
    }
</style>